module.exports = __webpack_public_path__ + "img/export_icon.dea9d34a.svg";